// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"571":"aec597c2","973":"baaca287"}[chunkId] + ".js";
};